/**
 * Maps Amplify / Cognito errors to user-facing messages.
 * The error.name field is the Cognito error class.
 */
export function describeAuthError(err: unknown): string {
  if (!err || typeof err !== 'object') return 'Unexpected error. Please try again.';
  const name = (err as { name?: unknown }).name;
  const message = (err as { message?: unknown }).message;
  switch (name) {
    case 'NotAuthorizedException':
      return 'Invalid email or password.';
    case 'UserNotFoundException':
      return 'No account found for that email.';
    case 'UserNotConfirmedException':
      return 'This account has not been confirmed yet. Check your email for a verification link.';
    case 'PasswordResetRequiredException':
      return 'A password reset is required. Use "Forgot password" to continue.';
    case 'CodeMismatchException':
      return 'The verification code is incorrect.';
    case 'ExpiredCodeException':
      return 'The verification code has expired. Request a new one.';
    case 'LimitExceededException':
      return 'Too many attempts. Please wait a few minutes and try again.';
    case 'InvalidPasswordException':
      return typeof message === 'string'
        ? message
        : 'Password does not meet the required complexity.';
    case 'AuthUserPoolException':
      return 'Authentication is not configured. Please contact support.';
    case 'NetworkError':
    case 'TypeError':
      return 'Network error. Please check your connection and try again.';
    default:
      return typeof message === 'string' && message.length > 0
        ? message
        : 'Sign-in failed. Please try again.';
  }
}
